<template>
  <div class="main-container">
    <div>
      <img src="../assets/images/under-maintenance.png" alt="img">
    </div>
    <div>
      <h2>{{ $t('maintenance.title') }}</h2>
      <p>{{ $t('maintenance.text') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnderMaintenance'
};
</script>

<style>
.main-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

